import * as React from "react";
const autobind = require("class-autobind").default;
import Dropzone from "react-dropzone";
import { FaTimes, FaUpload } from "react-icons/fa";
import styled from "../../../styled/index";
import { BaseInputCSS } from "../input/index";
import { withTranslation } from "react-i18next";
const Wrapper = styled("div") `
  ${BaseInputCSS};
  border-style: dashed;
  height: auto;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 20px;
  cursor: pointer;
  p {
    font-size: 14px;
  }
  h4 {
    font-size: 18px;
  }
`;
const WrapperInner = styled("div") `
  text-align: center;
`;
class FormDropzoneClass extends React.Component {
    constructor(props) {
        super(props);
        autobind(this);
        this.state = {
            error: "",
        };
    }
    onDrop(files) {
        const { t, onChange, maxFiles, maxSizeMegaBytes } = this.props;
        if (maxFiles !== undefined && files.length > maxFiles) {
            this.setState({
                error: t("components.field.dropzone.errors.max_files", { number: maxFiles }),
            });
            return;
        }
        if (maxSizeMegaBytes !== undefined) {
            for (const file of files) {
                if ((file.size / 1024 / 1024) > maxSizeMegaBytes) {
                    this.setState({
                        error: t("components.field.dropzone.errors.max_size", { kilobytes: Math.round(maxSizeMegaBytes * 1000) }),
                    });
                    return;
                }
            }
        }
        onChange(files);
        this.setState({ error: "" });
    }
    remove(e) {
        e.stopPropagation();
        this.props.onChange([]);
    }
    render() {
        const { error } = this.state;
        const { t, files, accept } = this.props;
        return (React.createElement(Dropzone, { accept: accept || "image/jpeg, image/png", onDrop: this.onDrop, className: "width100" },
            React.createElement(Wrapper, null,
                React.createElement(WrapperInner, null,
                    files.length !== 0 &&
                        React.createElement("div", null,
                            React.createElement("a", { onClick: this.remove, className: "block" },
                                React.createElement("h4", null,
                                    React.createElement(FaTimes, { className: "m-r-2" }),
                                    t("components.field.dropzone.remove"))),
                            files.map((f, i) => (React.createElement("p", { key: i, className: "m-t-2" }, f.name)))),
                    files.length === 0 &&
                        React.createElement("div", null,
                            React.createElement("h4", { className: "m-b-2" },
                                React.createElement(FaUpload, null)),
                            React.createElement("p", null, t("components.field.dropzone.drop_here")),
                            React.createElement("p", { className: "m-t-1" }, t("components.field.dropzone.accepts", { fileTypes: accept || "image/jpeg, image/png" }))),
                    error && (React.createElement("div", { className: "error-text m-t-2" },
                        React.createElement("p", { className: "font-semi-bold underline" }, error)))))));
    }
}
export const FormDropzone = withTranslation()(FormDropzoneClass);
//# sourceMappingURL=index.js.map